import { css } from 'styled-components';
import { colors, metrics } from '~/themes/variables';
const styles = css `
  width: 100%;
  max-width: ${metrics.maxWidth}px;
  margin: 0 auto;
  background: ${colors.snow};
  box-sizing: border-box;
  height: 100%;
`;
export default styles;
